'use client';

import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import Link from 'next/link';
import { notFound } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';

import useOuraGen4Enabled from '@/app/hooks/useOuraGen4Enabled';

const Content = (): JSX.Element => {
  const selectedLocale = useLocale();
  const t = useTranslations();
  const isGen4Enabled = useOuraGen4Enabled();

  if (!isGen4Enabled) {
    return notFound();
  }

  return (
    <LayoutGrid data-cy="fcc-compliance-statements">
      <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
        <TypographyV3 Element="h1" variant="h3" className="mb-4">
          {t('fcc_sdoc_index_title')}
        </TypographyV3>
        <TypographyV3 variant="h6" className="mb-8">
          {t('fcc_sdoc_index_copy')}
        </TypographyV3>
        <TypographyV3 className="mb-4 underline">
          <Link href={`/${selectedLocale}/fcc-compliance-statements/oa11`}>
            {t('fcc_sdoc_nav_header')} (OA11)
          </Link>
        </TypographyV3>
        <TypographyV3 className="mb-10 underline">
          <Link href={`/${selectedLocale}/fcc-compliance-statements/oa12`}>
            {t('fcc_sdoc_nav_header')} (OA12)
          </Link>
        </TypographyV3>
      </GridItem>
    </LayoutGrid>
  );
};

export default Content;
